
// ===== Emily's site comments, Oct 15, 2026: AI difference switch changes by itself =====
(function(){
  var t=document.querySelector('.chartcard .toggle'); if(!t) return;
  var bs=[].slice.call(t.querySelectorAll('button')); if(bs.length<2) return;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EVERY=5000, PAUSE=15000, pausedUntil=0, inView=false, timer=null;
  function cur(){for(var i=0;i<bs.length;i++){if(bs[i].classList.contains('on'))return i;}return 0;}
  function bar(){t.classList.remove('auto');void t.offsetWidth;if(inView&&Date.now()>=pausedUntil)t.classList.add('auto');}
  function start(){clearInterval(timer);if(reduce)return;bar();timer=setInterval(function(){
    if(!inView||Date.now()<pausedUntil||document.hidden)return;
    bs[(cur()+1)%bs.length].click();bar();},EVERY);}
  bs.forEach(function(b){b.addEventListener('click',function(e){
    if(e.isTrusted){pausedUntil=Date.now()+PAUSE;t.classList.remove('auto');
      setTimeout(function(){bar();},PAUSE+50);}});});
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(es){inView=es[0].isIntersecting;bar();},{threshold:.4}).observe(t.closest('.chartcard')||t);
  } else { inView=true; }
  start();
})();
